import router from "next/router";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import { APP_ROUTE_KEYS } from "repoV2/constants/urls&routing/routing";
import { constructRoute } from "repoV2/utils/urls&routing/routing";
import { URL_SEARCH_PARAMS } from "repoV2/constants/urls&routing/urlParams";
import { postAnalytics } from "repoV2/features/Common/Analytics/Analytics.utils";
import { ANALYTICS_EVENTS } from "repoV2/features/Common/Analytics/Analytics.constants";
import { useSalePageContext } from "../SalePageContext";

const useMainCtaClick = () => {
    const { isPreview, basicData } = useSalePageContext();
    const handleMainCtaClick = () => {
        if (isPreview) return;

        postAnalytics(ANALYTICS_EVENTS.SALE_PAGE_REGISTER_CTA_CLICK);

        if (basicData?.redirectUrl) {
            const redirectUrl = appendURLSearchParams(basicData.redirectUrl, {
                // to pass on the UTM params in the current url
                ...router?.router?.query,
            });
            window.open(redirectUrl, "_self");
        } else {
            router.push({
                pathname: constructRoute({
                    appRouteKey: APP_ROUTE_KEYS.EVENT,
                    args: { slug: basicData.listingUuid },
                }),
                query: {
                    // to pass on the UTM params in the current url
                    ...router?.router?.query,
                    [URL_SEARCH_PARAMS.INIT_BOOKING]: true,
                    [URL_SEARCH_PARAMS.COMPACT]: true,
                },
            });
        }
    };

    return { handleMainCtaClick };
};

export default useMainCtaClick;
